<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：会员-用户列表-会员等级
  -->
  <el-dialog title="技师位置" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <!-- <el-form-item label="是否获取文本">
          <el-select v-model="searchForm.is_text" placeholder="请选择">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="查看日期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.ymd" type="date" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getdrivingTrack">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading"
      :default-sort="{ prop: 'waiter_user_id', order: 'descending' }">
      <el-table-column prop="waiter_user_id" label="技师ID" width="100" sortable></el-table-column>
      <el-table-column prop="address" label="地址"></el-table-column>
      <el-table-column prop="lng" label="经度"></el-table-column>
      <el-table-column prop="lat" label="纬度"></el-table-column>
      <el-table-column prop="time" label="时间"></el-table-column>
    </el-table>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible(false)">取 消</el-button>
      <el-button type="primary" @click="addressedit" :loading="loading">确 定</el-button>
    </div> -->
  </el-dialog>
</template>

<script>
import Technician from "@/api/technician.js";
import Getpoint from "@/components/map/Getpoint.vue";
export default {
  components: {
    /*腾讯地图拾取器*/
    Getpoint
  },
  data() {
    return {
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      loading: false,
      dialogVisible: false,
      waiter_user_id: "",
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      searchForm: {
        waiter_user_id: "",
        is_text: 1,
        ymd: ''
      }
    };
  },
  props: ["open_waiterstep", "form"],
  created() {
    this.dialogVisible = this.open_waiterstep;
    this.waiter_user_id = this.form.waiter_user_id;
    this.searchForm.waiter_user_id = this.form.waiter_user_id;
    this.getdrivingTrack();
  },
  methods: {

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    /*获取*/
    getdrivingTrack() {
      let self = this;
      self.loading = true;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      Technician.getdrivingTrack(Params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.tableData = data.data.data;
            self.totalDataNumber = data.data.data.total;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/technician/technicianlist/dialog/waiterstep.vue